import React from 'react';
import Content from '../partials/Content.jsx';

const PropertyOffer = () => {
    return (<Content title="Оферта за нова полица Имот и имущество">
        <div>Очаквайте скоро!</div>
    </Content>);
};

export default PropertyOffer;
